import { postMethod } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const SEND_OTP = 'SEND_OTP';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const SEND_OTP_FAILURE = 'SEND_OTP_FAILURE';

// Action Creators
export const fetchSendOtp = () => ({
  type: SEND_OTP,
});

export const fetchSendOtpSuccess = (data) => ({
  type: SEND_OTP_SUCCESS,
  payload: data,
});

export const fetchSendOtpFailure = (error) => ({
  type: SEND_OTP_FAILURE,
  payload: error,
});

// Thunk Function
export const sendOtpCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchSendOtp(data, external));
    try {
      const response = await postMethod(url.sendOtp, data);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchSendOtpSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchSendOtpFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchSendOtpFailure(error.message));
    }
  };
};
